import React, { forwardRef, PropsWithChildren } from 'react';
import AppLayout, { AppLayoutProps } from '@cloudscape-design/components/app-layout';
import TopNavigation from '@cloudscape-design/components/top-navigation';

// Extend AppLayoutProps to include the header
interface CustomAppLayoutProps extends AppLayoutProps {
  header?: React.ReactNode;
}

export const CustomAppLayout = forwardRef<AppLayoutProps.Ref, PropsWithChildren<CustomAppLayoutProps>>(
  function CustomAppLayout(props, ref) {
    const { header, ...rest } = props;

    return (
      <>
        {header}
        <AppLayout ref={ref} {...rest} />
      </>
    );
  }
);

export default CustomAppLayout;
